import { ref } from 'vue'

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'cv-theme'

// Module-level singleton so every component shares the same reactive state.
const theme = ref<Theme>('dark')

// Color de la barra del navegador/PWA; igual a --c-bg de cada tema.
const THEME_COLOR: Record<Theme, string> = { dark: '#130f0c', light: '#f6f1ea' }

function apply(t: Theme) {
  const root = document.documentElement
  root.classList.toggle('dark', t === 'dark')
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[t])
}

export function useTheme() {
  function set(t: Theme) {
    theme.value = t
    try {
      localStorage.setItem(STORAGE_KEY, t)
    } catch {
      /* ignore quota / private mode */
    }
    apply(t)
  }

  function toggle() {
    set(theme.value === 'dark' ? 'light' : 'dark')
  }

  function init() {
    let initial: Theme
    try {
      const saved = localStorage.getItem(STORAGE_KEY) as Theme | null
      if (saved === 'light' || saved === 'dark') {
        initial = saved
      } else {
        initial = window.matchMedia?.('(prefers-color-scheme: light)').matches
          ? 'light'
          : 'dark'
      }
    } catch {
      initial = 'dark'
    }
    theme.value = initial
    apply(initial)
  }

  return { theme, set, toggle, init }
}
